import { registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import { LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core'
import { MatDialogModule } from '@angular/material/dialog'
import { MatMenuModule } from '@angular/material/menu'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics'
import { StorageServiceModule } from 'ngx-webstorage-service'

import { CdkTreeModule } from '@angular/cdk/tree'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTreeModule } from '@angular/material/tree'
import { ChartModule } from 'primeng/chart'
import { environment } from '../environments/environment'
import { LoginComponent } from './access/login/login.component'
import { MaintenanceComponent } from './access/maintenance/maintenance.component'
import { ConfirmPasswordValidatorDirective } from './access/reset-password-confirm/confirm-password-validator.directive'
import { ResetPasswordConfirmComponent } from './access/reset-password-confirm/reset-password-confirm.component'
import { ResetPasswordRequestComponent } from './access/reset-password-request/reset-password-request.component'
import { HideIfNotDirective } from './access/shared/authorization/hide-if-not.directive'
import { LoaderInterceptor } from './access/shared/loader-interceptor'
import { TokenInterceptor } from './access/shared/token/token-interceptor'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BasketComponent } from './customer-area/basket/basket.component'
import { CommandeLineComponent } from './customer-area/basket/commande-line/commande-line.component'
import { ConfirmDialogComponent } from './customer-area/basket/confirm-dialog/confirm-dialog.component'
import { ValidationDialogComponent } from './customer-area/basket/validation-dialog/validation-dialog.component'
import { BillingComponent } from './customer-area/billing/billing.component'
import { BordereauxComponent } from './customer-area/bordereaux/bordereaux.component'
import { BreadcrumbComponent } from './customer-area/breadcrumb/breadcrumb.component'
import { ContactFormComponent } from './customer-area/contact-us/contact-form/contact-form.component'
import { ContactUsComponent } from './customer-area/contact-us/contact-us.component'
import { FormatPhonePipe } from './customer-area/contact-us/shared/format.phone'
import { CustomerAreaComponent } from './customer-area/customer-area.component'
import { DailyOperationComponent } from './customer-area/daily-operation/daily-operation.component'
import { EditStockComponent } from './customer-area/daily-operation/lp/edit-stock/edit-stock.component'
import { LPComponent } from './customer-area/daily-operation/lp/lp.component'
import { PorteurAddComponent } from './customer-area/daily-operation/vt/porteur-add/porteur-add.component'
import { PorteurDotationFormComponent } from './customer-area/daily-operation/vt/porteur-add/porteur-dotation-form/porteur-dotation-form.component'
import { PorteurIdentityFormComponent } from './customer-area/daily-operation/vt/porteur-add/porteur-identity-form/porteur-identity-form.component'
import { AddArticleComponent } from './customer-area/daily-operation/vt/porteur-details/dotation/add-article/add-article.component'
import { CardArticleComponent } from './customer-area/daily-operation/vt/porteur-details/dotation/card-article/card-article.component'
import { ValRetArticleComponent } from './customer-area/daily-operation/vt/porteur-details/dotation/card-article/val-ret-article/val-ret-article.component'
import { DotationComponent } from './customer-area/daily-operation/vt/porteur-details/dotation/dotation.component'
import { EditDotationComponent } from './customer-area/daily-operation/vt/porteur-details/dotation/edit-dotation/edit-dotation.component'
import { CasierComponent } from './customer-area/daily-operation/vt/porteur-details/marquage/casier/casier.component'
import { FonctionComponent } from './customer-area/daily-operation/vt/porteur-details/marquage/fonction/fonction.component'
import { MarquageComponent } from './customer-area/daily-operation/vt/porteur-details/marquage/marquage.component'
import { NomComponent } from './customer-area/daily-operation/vt/porteur-details/marquage/nom/nom.component'
import { MutationComponent } from './customer-area/daily-operation/vt/porteur-details/mutation/mutation.component'
import { PorteurDetailsComponent } from './customer-area/daily-operation/vt/porteur-details/porteur-details.component'
import { PorteurListComponent } from './customer-area/daily-operation/vt/porteur-list/porteur-list.component'
import { DelValidationComponent } from './customer-area/daily-operation/vt/porteur/del-validation/del-validation.component'
import { PorteurComponent } from './customer-area/daily-operation/vt/porteur/porteur.component'
import { VTComponent } from './customer-area/daily-operation/vt/vt.component'
import { DavComponent } from './customer-area/dav/dav.component'
import { DeliveryDetailsComponent } from './customer-area/delivery/delivery-details/delivery-details.component'
import { DeliveryListComponent } from './customer-area/delivery/delivery-list/delivery-list.component'
import { DeliveryScheduleComponent } from './customer-area/delivery/delivery-schedule/delivery-schedule.component'
import { DeliveryComponent } from './customer-area/delivery/delivery.component'
import { WeekDayPipe } from './customer-area/delivery/shared/week-day/week-day.pipe'
import { FooterComponent } from './customer-area/footer/footer.component'
import { HomePageComponent } from './customer-area/home-page/home-page.component'
import { NotificationDialogComponent } from './customer-area/home-page/notification-dialog/notification-dialog.component'
import { LectureBilanComponent } from './customer-area/lecture-cab/lecture-bilan/lecture-bilan.component'
import { LectureCabComponent } from './customer-area/lecture-cab/lecture-cab.component'
import { LectureHistoriqueComponent } from './customer-area/lecture-cab/lecture-historique/lecture-historique.component'
import { LectureCheckComponent } from './customer-area/lecture-cab/lecture-import/lecture-check/lecture-check.component'
import { LectureDialogComponent } from './customer-area/lecture-cab/lecture-import/lecture-check/lecture-dialog/lecture-dialog.component'
import { LectureImportComponent } from './customer-area/lecture-cab/lecture-import/lecture-import.component'
import { LectureComponent } from './customer-area/lecture-cab/lecture-import/lecture/lecture.component'
import { MatPaginatorIntlFr } from './customer-area/lecture-cab/shared/mat-paginator-intl-fr'
import { BesoinDispatchValidateDialogComponent } from './customer-area/linge-hebergement/besoin/besoin-dispatch/besoin-dispatch-validate-dialog/besoin-dispatch-validate-dialog.component'
import { BesoinDispatchComponent } from './customer-area/linge-hebergement/besoin/besoin-dispatch/besoin-dispatch.component'
import { BesoinEditComponent } from './customer-area/linge-hebergement/besoin/besoin-edit/besoin-edit.component'
import { BesoinValidateDialogComponent } from './customer-area/linge-hebergement/besoin/besoin-edit/besoin-validate-dialog/besoin-validate-dialog.component'
import { BesoinListComponent } from './customer-area/linge-hebergement/besoin/besoin-list/besoin-list.component'
import { BesoinStatutHelpComponent } from './customer-area/linge-hebergement/besoin/besoin-list/besoin-statut-help/besoin-statut-help.component'
import { CommandeLingeriesEditComponent } from './customer-area/linge-hebergement/commande-lingeries/commande-lingeries-edit/commande-lingeries-edit.component'
import { CommandeValidateDialogComponent } from './customer-area/linge-hebergement/commande-lingeries/commande-lingeries-edit/commande-validate-dialog/commande-validate-dialog.component'
import { InventaireEditComponent } from './customer-area/linge-hebergement/commande-lingeries/inventaire-edit/inventaire-edit.component'
import { CommandeListComponent } from './customer-area/linge-hebergement/commande-list/commande-list.component'
import { CommandeStatutHelpComponent } from './customer-area/linge-hebergement/commande-list/commande-statut-help/commande-statut-help.component'
import { CommandeConfirmComponent } from './customer-area/linge-hebergement/commande/commande-confirm/commande-confirm.component'
import { CommandeEditComponent } from './customer-area/linge-hebergement/commande/commande-edit/commande-edit.component'
import { LingeHebergementComponent } from './customer-area/linge-hebergement/linge-hebergement.component'
import { CommandeEditDialogComponent } from './customer-area/linge-hebergement/shared/commande-edit-dialog/commande-edit-dialog.component'
import { CommandeEditReturnDialogComponent } from './customer-area/linge-hebergement/shared/commande-edit-return-dialog/commande-edit-return-dialog.component'
import { CommandeEditSendDialogComponent } from './customer-area/linge-hebergement/shared/commande-edit-send-dialog/commande-edit-send-dialog.component'
import { MentionsLegalesComponent } from './customer-area/mentions-legales/mentions-legales.component'
import { OrderDetailsComponent } from './customer-area/order/order-details/order-details.component'
import { OrderTrackingComponent } from './customer-area/order/order-tracking.component'
import { FilterMultiplePipe } from './customer-area/order/shared/filter/filter.pipe'
import { GetDataPipe } from './customer-area/order/shared/filter/get-data.pipe'
import { PasswordChangeComponent } from './customer-area/profile/password-change/password-change.component'
import { PersonalInformationComponent } from './customer-area/profile/personal-information/personal-information.component'
import { ProfileComponent } from './customer-area/profile/profile.component'
import { CommandeParamListComponent } from './customer-area/settings/commande-param/commande-param-list/commande-param-list.component'
import { CommandeParamConfirmModalComponent } from './customer-area/settings/commande-param/commande-param-settings/commande-param-confirm-modal/commande-param-confirm-modal.component'
import { CommandeParamSettingsModalComponent } from './customer-area/settings/commande-param/commande-param-settings/commande-param-settings-modal/commande-param-settings-modal.component'
import { CommandeParamSettingsComponent } from './customer-area/settings/commande-param/commande-param-settings/commande-param-settings.component'
import { StatisticsModalComponent } from './customer-area/settings/commande-param/commande-param-settings/commande-param-statistics-modal/statistics-modal.component'
import { ActivateLingerieModalComponent } from './customer-area/settings/commande-param/commande-param-settings/lingeries/activate-lingerie-modal/activate-lingerie-modal.component'
import { AddLingerieModalComponent } from './customer-area/settings/commande-param/commande-param-settings/lingeries/add-lingerie-modal/add-lingerie-modal.component'
import { UpdateLingerieModalComponent } from './customer-area/settings/commande-param/commande-param-settings/lingeries/update-lingerie-modal/update-lingerie-modal.component'
import { CommandeParamComponent } from './customer-area/settings/commande-param/commande-param.component'
import { DavParamEditComponent } from './customer-area/settings/dav-param/dav-param-edit/dav-param-edit.component'
import { DavParamListComponent } from './customer-area/settings/dav-param/dav-param-list/dav-param-list.component'
import { DavParamComponent } from './customer-area/settings/dav-param/dav-param.component'
import { SettingsComponent } from './customer-area/settings/settings.component'
import { UserDialogComponent } from './customer-area/settings/user/user-edit/user-dialog/user-dialog.component'
import { UserEditComponent } from './customer-area/settings/user/user-edit/user-edit.component'
import { UserListComponent } from './customer-area/settings/user/user-list/user-list.component'
import { UserComponent } from './customer-area/settings/user/user.component'
import { CUSTOM_DATE_FORMAT } from './customer-area/shared/datepicker/datepicker-format'
import { MomentFormatPipe } from './customer-area/shared/moment-format/moment-format.pipe'
import { TypeOfpipe } from './customer-area/shared/typeof/typeof.pipe'
import { ExportComponent as ExportStatsComponent } from './customer-area/statistic/export/export.component'
import { AddPlusPipe } from './customer-area/statistic/shared/add-plus.pipe.ts/add-plus.pipe'
import { FilterPipe } from './customer-area/statistic/shared/filter/filter.pipe'
import { StatisticRotationComponent } from './customer-area/statistic/statistic-rotation/statistic-rotation.component'
import { StatisticComponent } from './customer-area/statistic/statistic.component'
import { GestionComponent } from './customer-area/statistic/stats-LH/gestion/gestion.component'
import { ReturnValidationComponent } from './customer-area/statistic/stats-LH/gestion/return-validation/return-validation.component'
import { HistoriqueComponent } from './customer-area/statistic/stats-LH/historique/historique.component'
import { StatsLHDialogComponent } from './customer-area/statistic/stats-LH/stats-LH-dialog/stats-LH-dialog.component'
import { StatsLHComponent } from './customer-area/statistic/stats-LH/stats-LH.component'
import { AccountSelectorComponent } from './customer-area/tool-bar/account-selector/account-selector.component'
import { ContextComponent } from './customer-area/tool-bar/context/context.component'
import { ToolBarComponent } from './customer-area/tool-bar/tool-bar.component'
import { ToolsComponent } from './customer-area/tool-bar/tools/tools.component'
import { MaterialsModule } from './materials.module'
import { NotificationComponent } from './notification/notification.component'
import { NotificationInterceptorService } from './notification/shared/notification-interceptor.service'
import { StatisticLavageHelpComponent } from './customer-area/statistic/statistic-lavage-help/statistic-lavage-help.component'
import { DownloadDialogComponent } from './customer-area/bordereaux/download-dialog/download-dialog.component'
registerLocaleData(localeFr, 'fr')

@NgModule({
    declarations: [
        CustomerAreaComponent,
        PersonalInformationComponent,
        AppComponent,
        ResetPasswordConfirmComponent,
        ResetPasswordRequestComponent,
        LoginComponent,
        BasketComponent,
        BillingComponent,
        DailyOperationComponent,
        DeliveryComponent,
        FooterComponent,
        HomePageComponent,
        OrderTrackingComponent,
        ProfileComponent,
        SettingsComponent,
        ToolBarComponent,
        PasswordChangeComponent,
        ToolBarComponent,
        ToolsComponent,
        AccountSelectorComponent,
        ContextComponent,
        CommandeLineComponent,
        HideIfNotDirective,
        ConfirmPasswordValidatorDirective,
        NotificationComponent,
        DeliveryListComponent,
        DeliveryScheduleComponent,
        WeekDayPipe,
        UserComponent,
        UserListComponent,
        UserEditComponent,
        StatisticComponent,
        FilterPipe,
        DeliveryDetailsComponent,
        BreadcrumbComponent,
        TypeOfpipe,
        FilterMultiplePipe,
        BreadcrumbComponent,
        OrderDetailsComponent,
        MomentFormatPipe,
        GetDataPipe,
        ContactUsComponent,
        AddPlusPipe,
        ExportStatsComponent,
        VTComponent,
        LPComponent,
        PorteurComponent,
        StatisticRotationComponent,
        PorteurDetailsComponent,
        PorteurListComponent,
        DotationComponent,
        MutationComponent,
        CasierComponent,
        CardArticleComponent,
        EditDotationComponent,
        DelValidationComponent,
        ValidationDialogComponent,
        CommandeEditDialogComponent,
        AddArticleComponent,
        ValRetArticleComponent,
        PorteurAddComponent,
        PorteurIdentityFormComponent,
        PorteurDotationFormComponent,
        ContactFormComponent,
        EditStockComponent,
        FormatPhonePipe,
        ConfirmDialogComponent,
        LectureCabComponent,
        LectureImportComponent,
        LectureDialogComponent,
        LectureHistoriqueComponent,
        LectureBilanComponent,
        LectureCheckComponent,
        LectureComponent,
        FonctionComponent,
        NomComponent,
        MarquageComponent,
        LingeHebergementComponent,
        CommandeListComponent,
        CommandeParamSettingsComponent,
        CommandeParamSettingsModalComponent,
        CommandeParamComponent,
        CommandeEditComponent,
        CommandeConfirmComponent,
        CommandeParamListComponent,
        NotificationDialogComponent,
        DavParamComponent,
        DavParamEditComponent,
        DavParamListComponent,
        DavComponent,
        MaintenanceComponent,
        MentionsLegalesComponent,
        AddLingerieModalComponent,
        UpdateLingerieModalComponent,
        CommandeLingeriesEditComponent,
        InventaireEditComponent,
        CommandeValidateDialogComponent,
        CommandeListComponent,
        CommandeStatutHelpComponent,
        ActivateLingerieModalComponent,
        CommandeParamConfirmModalComponent,
        BesoinEditComponent,
        BesoinValidateDialogComponent,
        BesoinDispatchComponent,
        BesoinListComponent,
        BesoinStatutHelpComponent,
        BesoinDispatchValidateDialogComponent,
        StatsLHComponent,
        GestionComponent,
        HistoriqueComponent,
        UserDialogComponent,
        StatisticsModalComponent,
        StatsLHDialogComponent,
        StatisticsModalComponent,
        CommandeEditSendDialogComponent,
        ReturnValidationComponent,
        CommandeEditReturnDialogComponent,
        StatisticLavageHelpComponent,
        BordereauxComponent,
        DownloadDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        MaterialsModule,
        MatMomentDateModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        StorageServiceModule,
        FormsModule,
        MatSortModule,
        MatMenuModule,
        MatDialogModule,
        NgxGoogleAnalyticsModule.forRoot(environment.gaId),
        NgxGoogleAnalyticsRouterModule,
        MatTooltipModule,
        MatTreeModule,
        CdkTreeModule,
        MatIconModule,
        MatButtonModule,
        ChartModule,
        MatRippleModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NotificationInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlFr },
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
